import { Component, ViewEncapsulation } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { NgIf } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-user-cookies-consent',
    templateUrl: './user-cookies-consent.component.html',
    styleUrls: ['./user-cookies-consent.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatSlideToggle, ReactiveFormsModule, FormsModule, MatButton, TranslateModule],
})
export class UserCookiesConsentComponent {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cookieConsentValues: any = null;
    functional = true;
    analytics = false;
    advertisement = false;

    constructor(private analyticsService: AnalyticsService) {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (cookieConsent) {
            try {
                this.cookieConsentValues = JSON.parse(cookieConsent);
                this.functional = this.cookieConsentValues.functional;
                this.analytics = this.cookieConsentValues.analytics;
                this.advertisement = this.cookieConsentValues.advertisement;
                this.setConsent();
            } catch {
                localStorage.removeItem('cookieConsent');
                this.cookieConsentValues = null;
            }
        }
    }

    setConsent() {
        this.cookieConsentValues = {
            functional: this.functional,
            analytics: this.analytics,
            advertisement: this.advertisement,
        };
        this.analyticsService.setConsent(this.cookieConsentValues);
    }

    close() {
        this.cookieConsentValues = {
            functional: this.functional,
            analytics: this.analytics,
            advertisement: this.advertisement,
        };
        localStorage.setItem('cookieConsent', JSON.stringify(this.cookieConsentValues));
        console.log(this.cookieConsentValues);
    }

    acceptAll() {
        this.functional = true;
        this.analytics = true;
        this.advertisement = true;
        setTimeout(() => {
            this.cookieConsentValues = {
                functional: this.functional,
                analytics: this.analytics,
                advertisement: this.advertisement,
            };
            localStorage.setItem('cookieConsent', JSON.stringify(this.cookieConsentValues));
        }, 800);
    }
}
